import { Modal as ChakraModal } from '@chakra-ui/react'
import { ReactElement } from 'react'

import { ModalProps } from './Modal.types'

export default function Modal(props: ModalProps): ReactElement {
  return <ChakraModal isCentered {...props} />
}
